import items from "@/data/recovery/items.json";
import type { CloudAllData } from "@/types/cloud-data";

// The Unity-exported item catalogue includes individual pieces and default outfits.
export const COSTUME_CATALOG = items
  .filter(item => item.category === "costume" && item.costume)
  .map(item => ({
    id: item.id,
    name: item.name,
    hero: item.costume!.hero ?? 0,
    part: item.costume!.costumePart ?? 0,
    set: item.costume!.setName ?? "",
    alwaysUnlocked: item.costume!.costumeType === 0,
  }))
  .sort((a, b) => a.hero - b.hero || a.set.localeCompare(b.set) || a.part - b.part || a.name.localeCompare(b.name));

export function readCostumeUnlocks(cloud: CloudAllData): Record<string, number> | null {
  const saved = cloud.userData?.costumes;
  if (saved == null) return {};
  if (typeof saved !== "object" || Array.isArray(saved) ||
      !Object.values(saved).every(value => typeof value === "number" && Number.isInteger(value))) return null;
  return saved as Record<string, number>;
}

export function setCostumeUnlocked(cloud: CloudAllData, id: string, unlocked: boolean): CloudAllData {
  const saved = readCostumeUnlocks(cloud);
  const costume = COSTUME_CATALOG.find(item => item.id === id);
  if (!saved || !costume || costume.alwaysUnlocked) return cloud;
  const costumes = { ...saved };
  // The game checks key presence, so locking must remove the key rather than set zero.
  if (unlocked) costumes[id] = costumes[id] ?? 1;
  else delete costumes[id];
  return { ...cloud, userData: { ...cloud.userData, costumes } };
}
